/* MTXbudget — full black for the phone layout, laid over the Midnight theme
   (see 05-maquettes: QuinzaineNoir, EtatNoir). Only what differs is listed. */
:root {
  --color-pageBackground: #000000;
  --color-pageText: #e8e8ee;
  --color-pageTextDark: #ffffff;
  --color-pageTextSubdued: #9c9cab;

  --color-mobilePageBackground: #000000;
  --color-mobileViewTheme: #000000;
  --color-mobileHeaderBackground: #000000;
  --color-mobileHeaderText: #ffffff;
  --color-mobileHeaderRule: #24242c;
  --color-mobileNavBackground: #000000;
  --color-mobileNavItem: #9c9cab;
  --color-mobileNavItemSelected: #b58cff;

  --color-cardBackground: #0f0f14;
  --color-tableBackground: #0f0f14;
  --color-tableHeaderBackground: #17171d;
  --color-tableBorder: #24242c;
  --color-menuBackground: #17171d;
  --color-menuBorder: #24242c;
  --color-modalBackground: #17171d;

  --color-buttonPrimaryBackground: #8719e0;
  --color-buttonPrimaryBackgroundHover: #9446ed;
  --color-buttonNormalBackground: #0f0f14;
  --color-buttonNormalBorder: #24242c;
  --color-buttonNormalText: #e8e8ee;
  --color-formInputBackground: #0f0f14;
  --color-formInputBorder: #24242c;

  --color-noticeTextLight: #4fd1a5;
  --color-warningText: #f0b34a;
}
